import { getExtensions } from '@atlassian/relay-capture-extensions';

// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths
import SearchResultsQuery from '../../../ui/search-page-relay/search-results/__generated__/searchResultsQuery.graphql';

import { getQueryUpdatedTime } from './query-updated-time';

export type ExtensionData = {
	traceId: string | undefined;
	queryUpdatedAgo: number | undefined;
};

export function getExtensionData(): ExtensionData {
	const extensions = getExtensions(SearchResultsQuery.operation.name)?.at(-1) as
		| Record<string, any>
		| undefined;
	const gateway = extensions?.gateway;
	const traceId = gateway?.['trace_id'];
	const queryUpdatedAgo = getQueryUpdatedTime();
	return { traceId, queryUpdatedAgo };
}
